module.exports = __webpack_public_path__ + "img/yidesc.5f8ddb4d.jpg";